// noinspection JSDeprecatedSymbols

import posthog from 'posthog-js'

export const usePosthogCapture = () => {
  const posthogCapture = (type: string) => {
    posthog.capture(`${type} clicked`, {
      $browser: navigator.userAgent,
      $device_type: navigator.userAgent.includes('Mobi') ? 'mobile' : 'desktop',
      $os: getOS(),
      $screen_width: window.visualViewport?.width,
      $timestamp: new Date().toISOString(),
      type,
    })
  }

  const getOS = () => {
    const userAgent = window.navigator.userAgent
    const platform = window.navigator.platform
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
    const iosPlatforms = ['iPhone', 'iPad', 'iPod']

    if (macosPlatforms.includes(platform)) return 'Mac OS'
    if (iosPlatforms.includes(platform)) return 'iOS'
    if (windowsPlatforms.includes(platform)) return 'Windows'
    if (/Android/.test(userAgent)) return 'Android'
    if (/Linux/.test(userAgent)) return 'Linux'
    return 'Unknown'
  }

  return { posthogCapture }
}

export { useFeatureFlagVariantKey } from 'posthog-js/react'
